import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const UserInputStat = ({ code, caption, label, placeHolder, allowEmptyInput, showViewButton, endpoint, handleSubmit }) => {
  const [userInput, setInputValue] = useState("");
  const [error, setError] = useState(null);

  const labelParameter = label ?? "";
  const placeholder = placeHolder ?? "";
  const isViewButtonVisible = showViewButton ?? false;


  const handleInputChange = (e) => {
    const value = e.target.value;

    if (!allowEmptyInput && value.trim() === "") {
      setError(placeholder);
    } else {
      setError(null);
    }

    setInputValue(value);
  };

  const doSubmit = (e, format) => {
    e.preventDefault();

    if (!allowEmptyInput && userInput.trim() === "") {
      setError(placeholder);
      return;
    }
    const payload = {
      reportCode: code,
      userInput: userInput
    };
    handleSubmit(e, endpoint, payload, format);
  };

  return (
    <div className="container my-5">
      <div className="card p-3">
        <h5 className="card-title">{caption} </h5>
        <form>
          <div className="row align-items-end">
            <div className="col-md-4 mb-3">
              <label htmlFor="userInput" className="form-label">
                {labelParameter}
              </label>
              <input
                type="text"
                className="form-control"
                id="userInput"
                value={userInput}
                placeholder={placeholder}
                onChange={handleInputChange}
              />
              {error && <div className="alert alert-danger">{error}</div>}
            </div>
            <div className="col-md-4 mb-3 offset-md-4 text-end">
              {isViewButtonVisible && <button type="button" className="btn btn-primary me-2" onClick={(e) => doSubmit(e, 'json')}>
                <FontAwesomeIcon icon="eye" />
                Apri
              </button>}
              <button type="button" className="btn btn-primary" onClick={(e) => doSubmit(e, 'csv')}>
                <FontAwesomeIcon icon="download" />
                Scarica
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
};

export default UserInputStat;